module.exports = __webpack_public_path__ + "static/sunken-forest.20387250.jpg";